import Box from '@mui/material/Box'
import ErrorIcon from '@mui/icons-material/Error'
import Typography from '@mui/material/Typography'

const RequestError = ({ error }) => {
  return (
    <Box
      sx={{
        height: '240px',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        py: '40px',
        px: '20px',
      }}
    >
      <ErrorIcon sx={{ fontSize: 40, color: 'light-gray-text.main', mb: '20px' }} />
      <Typography variant="h4" color={'light-gray-text.main'} sx={{ mb: '6px' }}>
        ERROR
      </Typography>
      <Typography variant="body1" color={'light-gray-text.main'} textAlign="center">
        {error.message}
      </Typography>
    </Box>
  )
}

export default RequestError
